if (!customElements.get('pdp-dyo-material-card')) {
  class PdpDyoMaterialCard extends HTMLElement {
    constructor() {
      super();
      this.showInfoButton = null;
      this.handleInfoToggle = this.handleInfoToggle.bind(this);
      this.handleInfoClose = this.handleInfoClose.bind(this);
    }

    connectedCallback() {
      this.showInfoButton = this.querySelector('.js-dyo-material-info-button');
      this.closeInfoButton = this.querySelector(
        '.js-dyo-material-info-close-button',
      );
      this.addEventListener('mouseleave', this.handleInfoClose);
      this.handleEventManager();
    }

    disconnectedCallback() {
      this.handleEventManager(false);
      this.removeEventListener('mouseleave', this.handleInfoClose);
    }

    handleInfoToggle() {
      const isHidden = this.classList.contains('info-shown');
      this.classList.toggle('info-shown', !isHidden);
      this.publishEvent('material-info-toggled', { shown: !isHidden });
    }

    handleInfoClose() {
      this.classList.remove('info-shown');
      this.publishEvent('material-info-toggled', { shown: false });
    }

    /**
     * Adds or removes event listeners for info toggle and close buttons.
     *
     * @param {boolean} [add=true] - If true, adds event listeners; if false, removes them.
     *
     * - Adds/removes click event for the info button to toggle info display.
     * - Adds/removes click event for the close button to hide info display.
     */
    handleEventManager(add = true) {
      const method = add ? 'addEventListener' : 'removeEventListener';

      if (this.showInfoButton) {
        this.showInfoButton[method]('click', this.handleInfoToggle);
      }

      if (this.closeInfoButton) {
        this.closeInfoButton[method]('click', this.handleInfoClose);
      }
    }

    /**
     * Publishes a custom event from this component.
     * @param {string} eventName - The name of the event to dispatch.
     * @param {Object} [detail] - Optional detail object to include in the event.
     */
    publishEvent(eventName, detail = {}) {
      this.dispatchEvent(
        new CustomEvent(eventName, {
          detail,
          bubbles: true,
          composed: true,
        }),
      );
    }
  }
  customElements.define('pdp-dyo-material-card', PdpDyoMaterialCard);
}
